const supportedLocales = [
  'af','sq','hy','bs','bg','ca','hr','cs','da','nl','en','et','fo',
  'fi','fr','gd','de','el','hu','is','id','it','la','lv','lt','mk',
  'mo','no','nb','nn','pl','pt-BR','pt-PT','ro','ru','sr','sh','sk',
  'sl','es','sv','tr','uk','vi','cy'
]

function showShopifyRegionSearchDrawer(){
  $('.main-search-region').css({
    "visibility": "visible",
    "pointer-events": "auto",
    "opacity": "1",
    "height": "100vh"
  });

  // ✅ Trigger lazyload + fix {width}
  setTimeout(function() {
    $('.main-search-region img.lazyload--manual').each(function() {
      var $img = $(this);
      $img.removeClass('lazyload--manual');
      $img.addClass('lazyload');
    });
  }, 50);

  $('body').addClass('no-scroll');
  $('.section-announcement-bar').css('visibility', "hidden");
  $('.main-search__input').eq(1).focus();
  // hide results for main-search
  $('.main-search-region .main-search__input').val('');
  $('.main-search-region .main-search__input').trigger('keyup');
}

function hideShopifyRegionSearchDrawer(){
  $('.main-search-region').css({
    "visibility": "hidden",
    "pointer-events": "none",
    "opacity": "0",
  });
  $('body').removeClass('no-scroll');
  $('.section-announcement-bar').css('visibility',"visible");
  // hide results for main-search
  var oldSearchVal = $('.main-search .main-search__input').val();
  $('.main-search .main-search__input').val('');
  $('.main-search .main-search__input').trigger('keyup');
  $('.main-search .main-search__input').val(oldSearchVal);
  $('.main-search .main-search__input').trigger('keyup');
}

$(document).ready(function(){
  $('[href="#main-search"]').attr('onclick','showShopifySearchDrawer();return false;');
  $('[href="#main-search"]').attr('href','#');
  $('[href="#region-search"]').attr('onclick','showShopifyRegionSearchDrawer();return false;');
  $('[href="#region-search"]').attr('href','#');
  $('.main-search-region__close').attr('onclick','hideShopifyRegionSearchDrawer();');

  // BEGIN CUSTOM CODE to replicate region predictive search
  $(document).on("keyup", ".main-search-region .main-search__input", function (event) {
    // Ignore keys that don't modify input (arrows, control, etc.)
    const ignoredKeys = [
      'Shift', 'Control', 'Alt', 'Meta', 'ArrowLeft', 'ArrowRight',
      'ArrowUp', 'ArrowDown', 'Escape', 'CapsLock', 'Tab', 'Enter'
    ];
    if (ignoredKeys.includes(event.key)) {
      return;
    }
    
    const $form = $(this).closest("form");
    const $container = $(".main-search-region");
    const $results = $container.find(".main-search__results");
    const query = $(this).val();
    const resultLimit = 8;
    const showPrice = $container.data("live-search-price");
    const showVendor = $container.data("live-search-vendor");
    const includeMeta = $container.data("live-search-meta");
  
    clearTimeout(window._predictiveTimeout);
    if (query.length <= 2) {
      $container.removeClass("main-search--has-results main-search--loading");
      $results.empty();
      return;
    }
  
    $container.removeClass("main-search--has-results main-search--no-results").addClass("main-search--loading");
    $results.html('<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>');
    // BEGIN Custom Code to convert suppoted locales for predictive search
    var predictive_search_url = Shopify.locale + '/search/suggest';
    if ( (!supportedLocales.includes(Shopify.locale)) || (Shopify.locale == "en") ){
      var predictive_search_url = '/search/suggest';
    }
  
    window._predictiveTimeout = setTimeout(() => {
      $.ajax({
        url: predictive_search_url,
        data: {
          q: query,
          section_id: 'predictive-search',
          locale: Shopify.locale,
          resources: {
            type: $form.find('input[name="type"]').val(),
            limit: resultLimit,
            options: {
              unavailable_products: "last",
              fields: 'title,tag'
            }
          }
        },
        dataType: "html",
        success: function (response) {
          const $html = $('<div>').html(response);
          const $list = $html.find(".product-list");
  
          $results.empty();
          $container.removeClass("main-search--loading");
  
          if (!$list.length) {
            $container.addClass("main-search--no-results");
            $results.append('<div class="main-search__empty-message">Sorry, we couldn’t find any results.</div>');
            return;
          }
  
          // Update links for locale
          $list.find('[href]').each(function () {
            const href = $(this).attr('href');
            if (Shopify.locale !== 'en' && href.startsWith('/') && !href.startsWith('/' + Shopify.locale)) {
              $(this).attr('href', '/' + Shopify.locale + href);
            }
          });
  
          let $products = $list.find('.product-block:not(.collection-block):not(.page-block)');
          let $collections = $list.find('.product-block.collection-block');
          let $pages = $list.find('.product-block.page-block');
  
          if ($products.length || $collections.length || $pages.length) {
            $container.addClass("main-search--has-results");
  
            const $productContainer = $('<div class="main-search__results__products"><div class="collection-listing"></div></div>');
            $products.slice(0, resultLimit).each(function () {
              $(this).addClass('main-search-result');
              if (!showPrice) $(this).find('.product-price').remove();
              if (!showVendor) $(this).find('.vendor').remove();
              $productContainer.children().first().append($(this));
            });
  
            if ($products.length){
              
              $results.append($productContainer);
            }
  
            if ($collections.length) {
              const $collectionWrap = $('<div class="main-search__results__collections"><h6 class="main-search-result__heading">Regions</h6><div class="collection-listing"></div></div>');
              $collections.each(function () {
                $(this).addClass("main-search-result");
                $collectionWrap.find('.collection-listing').append($(this));
              });
              $results.append($collectionWrap);
              $('.main-search-result').css('opacity',"1");
            }
  
            if ($pages.length) {
              const $pageContainer = $('<div class="main-search__results__pages"><h6 class="main-search-result__heading">Pages</h6></div>');
              $pages.each(function () {
                const $link = $('<a class="main-search-result main-search-result--page">')
                  .attr('href', $(this).find("a:first").attr("href"))
                  .append(`<div class="main-search-result__text">${$(this).find('.page-block__title').text()}</div>`);
                $pageContainer.append($link);
              });
              $results.append($pageContainer);
            }
  
            // $results.append(`<a class="main-search__results-all-link button altcolour" href="${$form.attr('action')}?q=${query}">See all results</a>`);
          } else {
            $container.addClass("main-search--no-results");
            $results.append('<div class="main-search__empty-message">Sorry, we couldn’t find any results.</div>');
          }
        },
        error: function () {
          $container.removeClass("main-search--loading").addClass("main-search--no-results");
          $results.html('<div class="main-search__empty-message">An error occurred. Please try again.</div>');
        }
      });
    }, 400);
  });
  // END CUSTOM CODE to replicate region predictive search
  
})

